module.exports = __webpack_public_path__ + "static/media/load-wallet.d78d6b88.svg";